import React from 'react';

import { useStore } from '@vromo/mobx-react';
import { observer } from 'mobx-react-lite';

import { Dispatch } from '@vromo/models';

import capitalize from 'lodash/capitalize';

import format from 'date-fns/format';
import isThisYear from 'date-fns/is_this_year';
import Tooltip from '@vromo/ui/components/Tooltip';
import FontAwesome from '@vromo/ui/components/FontAwesome';

interface Props {
    dispatch: Dispatch;
    returnReason?: string;
}

export default observer<Props>(function AuditHistoryItem({ dispatch, returnReason }) {
    const { created, audit } = dispatch;

    const date = format(created!, `DD MMM ${isThisYear(created!) ? '' : 'YYYY'} HH:mm `);

    const auditUserName = audit?.user?.displayName ?? 'Unknown user';

    const auditUser =
        audit && audit.type !== 'auto'
            ? `by ${auditUserName} (${capitalize(audit.type)})`
            : `(${capitalize(audit?.type)})`;

    const driverName = dispatch.vehicle?.driver?.contact?.name ?? 'Unknown user';

    const driver =
        dispatch.type &&
        ['dispatched', 'returned'].includes(dispatch.type) &&
        ` ${dispatch.type === 'dispatched' ? 'to' : 'from'} ${driverName}`;

    return (
        <div
            key={dispatch.id}
            style={{
                marginBottom: 10,
                display: 'flex',
                flexDirection: 'column'
            }}>
            <div style={{ display: 'flex', marginBottom: 5 }}>
                <strong style={{ marginRight: 3 }}>{capitalize(dispatch.type)}</strong>
                {driver}
                {!!returnReason && (
                    <Tooltip position="bottom" label={returnReason}>
                        <div style={{ marginLeft: 4 }}>
                            <FontAwesome icon="info-circle" />
                        </div>
                    </Tooltip>
                )}
            </div>

            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    fontWeight: 300
                }}>
                <div>
                    {date}
                    {auditUser}
                </div>
            </div>
        </div>
    );
});
